export function hasAlipayPaymentBridge() {
  return window.NaviconfPayments?.version === 1
    && typeof window.ReactNativeWebView?.postMessage === "function";
}

// Новый сценарий премиума не затрагивает навигацию покупки билетов и пополнения.
// SDK сообщает только результат попытки; подтверждение оплаты остаётся за API.
export function startAlipayPayment(orderString, onResult) {
  if (!hasAlipayPaymentBridge()) throw new Error("premium_update_app");
  const requestId = `premium-${Date.now()}-${Math.random().toString(36).slice(2)}`;
  const handleResult = (event) => {
    if (event.detail?.v !== 1 || event.detail?.request_id !== requestId) return;
    cleanup();
    onResult(event.detail);
  };
  const cleanup = () => window.removeEventListener("naviconf:alipay-result", handleResult);
  window.addEventListener("naviconf:alipay-result", handleResult);
  try {
    window.ReactNativeWebView.postMessage(JSON.stringify({
      v: 1, type: "payment.alipay", request_id: requestId, order_string: orderString,
    }));
  } catch (error) {
    cleanup();
    throw error;
  }
  return cleanup;
}
